import { render, staticRenderFns } from "./Pagos.vue?vue&type=template&id=ed81890a&scoped=true"
import script from "./Pagos.vue?vue&type=script&lang=js"
export * from "./Pagos.vue?vue&type=script&lang=js"
import style0 from "./Pagos.vue?vue&type=style&index=0&id=ed81890a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed81890a",
  null
  
)

export default component.exports